import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'

// Api
import { uploadTicketCommentAttachment } from 'api/ticket-comment'

// Use
import useUploadHook, { STATUS_DONE } from 'use/upload'

// Component
import Modal from 'ui/Modal'
import Row from 'ui/Row'
import Col from 'ui/Col'
import Button from 'ui/Button'
import Text from 'ui/Text'
import FileDropZone from 'ui/FileDropZone'
import FileItem from 'ui/FileItem/FileItem'

const accept = '.xls,.xlsx,.jpg,.jpeg,.pdf'
const maxFileSize = 20
const totalSize = 20
const multiple = true
const autoupload = true

export const PopupAttachFile = ({ files: uploadedFiles, onSaved }) => {
  // State
  const [visible, setVisible] = useState(true)

  const onUpload = async ({ file, onUploadProgress, onError, onSuccess }) => {
    try {
      const fileName = await uploadTicketCommentAttachment({
        file,
        onUploadProgress,
      })

      onSuccess({ name: fileName })
    } catch (error) {
      onError(error)
    }
  }

  const { files, uploading, removeFile, onFileChange } = useUploadHook({
    accept,
    autoupload,
    maxFileSize,
    totalSize,
    multiple,
    uploadedFiles,
    onUpload,
  })

  const newFiles = useMemo(() => files.filter((x) => x.isNew === true), [files])

  const onClickSave = () => {
    onSaved(newFiles)

    setVisible(false)
  }

  return (
    <Modal show={visible}>
      <Text bold color="#000000" size={20}>
        Attache a file
      </Text>
      <Text color="#000000" size={15}>
        Select file from your computer or drag file to attach
      </Text>
      <Text italic color="#AFAFAF" size={14} paddingBottom={15}>
        File must be less than 20MB of .xls, .xlsx, .jpg or .pdf file
      </Text>

      <FileDropZone
        size="sm"
        accept={accept}
        multiple={multiple}
        onChange={onFileChange}
      />

      {newFiles.map((file, index) => (
        <FileItem
          key={index}
          name={file.name}
          size={file.size}
          error={file.error}
          status={file.status}
          percent={file.percent}
          onRemove={file.status === 'done' ? null : () => removeFile(file.id)}
        />
      ))}

      <br />

      <Row>
        <Col xs={6}>
          <Button
            block
            variant="outline-primary"
            disabled={uploading}
            onClick={() => setVisible(false)}
          >
            Cancel
          </Button>
        </Col>
        <Col xs={6}>
          <Button
            block
            disabled={
              !files.every((file) => file.status === STATUS_DONE) ||
              !files.length
            }
            onClick={onClickSave}
          >
            Save
          </Button>
        </Col>
      </Row>
    </Modal>
  )
}

PopupAttachFile.propTypes = {
  files: PropTypes.array,
  onSaved: PropTypes.func,
}

PopupAttachFile.defaultProps = {
  files: [],
  onSaved: () => {},
}

export default PopupAttachFile
